module.exports = __webpack_public_path__ + "static/img/btn1.ce4f58c9.png";